<template>
  <div>
    <el-table
        :data="tableData"
        border
        v-bind="$attrs"
        v-on="$listeners"
        ref="table"
        @selection-change="handleSelectionChange"
        style="width: 100%"
    >
      <!-- 第二序号列 -->
      <el-table-column
          v-if="show2Index"
          align="center"
          type="index"
          :label="indexLabel"
          :width="indexWidth"
          :fixed="indexFixed"
          :index="indexMethod"
      >
        <template slot="header">
          <span></span>
        </template>
      </el-table-column>

      <!-- 复选框列 -->
      <el-table-column
          v-if="showSelection"
          align="center"
          type="selection"
          :width="selectionWidth"
          :fixed="selectionFixed"
      />

      <!-- 序号列 -->
      <el-table-column
          v-if="showIndex"
          align="center"
          type="index"
          :label="indexLabel"
          :min-width="indexWidth"
          :fixed="indexFixed"
          :index="indexMethod"
      />

      <!-- 可拖拽列 -->
      <el-table-column
          v-for="(column, index) in internalColumns"
          :key="column.prop || index"
          align="center"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :type="column.type"
          :fixed="column.fixed"
          :sortable="column.sortable"
      >
        <!-- 表头 -->
        <template slot="header">
          <div
              class="column-header"
              draggable="true"
              @dragstart="onDragStart(index)"
              @dragover.prevent="onDragOver($event, index)"
              @drop.prevent="onDrop(index)"
              @contextmenu.prevent="onContextMenu($event, column, index)"
          >
            <span>{{ column.name }}</span>
            <span v-if="column.sortable" class="sort-icon">↕️</span>
          </div>
        </template>

        <!-- 内容插槽 -->
        <template v-if="column.slotName" slot-scope="scope">
          <slot :name="column.slotName" v-bind="scope" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 右键菜单 -->
    <div
        v-if="contextMenu.visible"
        class="context-menu"
        :style="contextMenuStyle"
    >
      <div class="menu-item" @click="closeCurrentColumn">
        <span class="menu-icon">❌</span>
        <span class="menu-text">关闭</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DraggableTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    draggable: {
      type: Boolean,
      default: true
    },
    showSelection: Boolean,
    selectionWidth: {
      type: [String, Number],
      default: '55'
    },
    selectionFixed: {
      type: [String, Boolean],
      default: false
    },
    showIndex: Boolean,
    show2Index: Boolean,
    indexLabel: {
      type: String,
      default: '序号'
    },
    indexWidth: {
      type: [String, Number],
      default: '55'
    },
    indexFixed: {
      type: [String, Boolean],
      default: false
    }
  },
  data() {
    return {
      internalColumns: [],
      dragIndex: null,
      contextMenu: {
        visible: false,
        x: 0,
        y: 0,
        column: null,
        index: -1
      }
    }
  },
  computed: {
    contextMenuStyle() {
      return {
        left: this.contextMenu.x + 'px',
        top: this.contextMenu.y + 'px'
      }
    }
  },
  watch: {
    columns: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.internalColumns = newVal.map(col => ({
          ...col,
          prop: col.key,
          label: col.name,
          width: col.minWidth,
          slotName:
              col.slotName === true || col.slotName === ''
                  ? ''
                  : col.key
        }))
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    indexMethod(index) {
      return index + 1
    },

    handleSelectionChange(selection) {
      this.$emit('selection-change', selection)
    },

    onDragStart(index) {
      if (!this.draggable) return
      this.dragIndex = index
    },

    onDragOver(e, index) {
      if (!this.draggable || this.dragIndex === index) return
      e.currentTarget.classList.add('drag-over')
    },

    onDrop(dropIndex) {
      if (!this.draggable || this.dragIndex === null) return

      const moved = this.internalColumns.splice(this.dragIndex, 1)[0]
      this.internalColumns.splice(dropIndex, 0, moved)

      this.$emit('column-drop', {
        oldIndex: this.dragIndex,
        newIndex: dropIndex,
        columns: [...this.internalColumns]
      })

      this.$emit('update:columns', [...this.internalColumns])

      this.dragIndex = null
      this.clearDragStyle()
    },

    clearDragStyle() {
      const headers = document.querySelectorAll('.column-header')
      headers.forEach(el => el.classList.remove('drag-over'))
    },

    onContextMenu(e, column, index) {
      this.contextMenu = {
        visible: true,
        x: e.clientX,
        y: e.clientY,
        column,
        index
      }
    },

    handleClickOutside(e) {
      if (
          this.contextMenu.visible &&
          !e.target.closest('.context-menu')
      ) {
        this.contextMenu.visible = false
      }
    },

    closeCurrentColumn() {
      if (this.contextMenu.index !== -1) {
        this.$emit('column-close', {
          column: this.contextMenu.column,
          index: this.contextMenu.index
        })
      }
      this.contextMenu.visible = false
    }
  }
}
</script>
<style scoped>
.column-header {
  cursor: move;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 24px;
}

.column-header:hover {
  background: #f5f7fa;
  border-radius: 4px;
}

.column-header.drag-over {
  background: #e6f7ff;
  border: 2px dashed #1890ff;
}

.sort-icon {
  font-size: 12px;
  margin-left: 4px;
}

.context-menu {
  position: fixed;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  z-index: 9999;
}

.menu-item {
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.menu-item:hover {
  background: #f5f7fa;
}

.menu-icon {
  margin-right: 8px;
}
</style>
